import { render, staticRenderFns } from "./PzUnnaxBankAggregation.vue?vue&type=template&id=4ef31ffd&"
import script from "./PzUnnaxBankAggregation.vue?vue&type=script&lang=js&"
export * from "./PzUnnaxBankAggregation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef31ffd')) {
      api.createRecord('4ef31ffd', component.options)
    } else {
      api.reload('4ef31ffd', component.options)
    }
    module.hot.accept("./PzUnnaxBankAggregation.vue?vue&type=template&id=4ef31ffd&", function () {
      api.rerender('4ef31ffd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Fields/OpenBanking/PzUnnaxBankAggregation.vue"
export default component.exports